import { ReactElement } from 'react'

import { useExpenseRevampFeatureFlags } from '@views/bills/hooks/useExpenseRevampFeatureFlags'
import { ContactsList } from '@views/contacts/elements/ContactsList'

import { SuppliersListRevamped } from './SuppliersListRevamped'

export const SuppliersList = (): ReactElement | null => {
  const { areFlagsLoading, isRevampedPurchaseListEnabled } = useExpenseRevampFeatureFlags()

  // Rendering the legacy list while the flag resolves would fire its own contacts
  // request and write its filters into the URL, both of which outlive the swap.
  if (areFlagsLoading) {
    return null
  }

  if (!isRevampedPurchaseListEnabled) {
    return <ContactsList isCustomer={false} isSupplier />
  }

  return <SuppliersListRevamped />
}
